import { render, staticRenderFns } from "./servantDetail.vue?vue&type=template&id=32eaa820&scoped=true"
import script from "./servantDetail.vue?vue&type=script&lang=js"
export * from "./servantDetail.vue?vue&type=script&lang=js"
import style0 from "./servantDetail.vue?vue&type=style&index=0&id=32eaa820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eaa820",
  null
  
)

export default component.exports